module.exports = __webpack_public_path__ + "img/button5.fc591ef1.png";